import wrlog from './Helper/functions/wrlog';

// wrlog("ENV", process.env)

export const BASENAME = '';
export const MAINTENANCE = false; // process.env.REACT_APP_MAINTENANCE === 'true';
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT; // process.env.REACT_APP_API_ENDPOINT;
